module.exports = __webpack_public_path__ + "assets/images/restaurant-03.ff65449fc65b3dbfaa9c453b5482a34b.svg";